jQuery(document).ready(function($) {
  $('.products-slick').slick({
    dots: true,
    customPaging : function(slider, i) {
        return '<button type="button" role="tab" id="slick-slide-control00" class="slide-dot" aria-controls="slick-slide00" aria-label="1 of 2"></button>';
    },
    arrows: false,
    infinite: true
  });
});
